import { memo } from "react";

const Loading = ({ className }) => (
    <div className={`lds-ellipsis${className ? ` ${className}` : ""}`}><div></div><div></div><div></div><div></div></div>
);

export default memo(Loading);